import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./students.css";
import IsLoading from "../../../isLoading";
import { useAdminPermission } from "../adminPermission";
import { useSelector } from "react-redux";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { useSnackbar } from "notistack";
import ExportPDFButton from "./StudentExportPdf";

// import from MUI
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import SearchIcon from "@mui/icons-material/Search";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import TocOutlinedIcon from "@mui/icons-material/TocOutlined";
import ExportExcelJSButton from "./StudentExcelExport";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
let dataFetch;

export default function Students() {
  const permission = useAdminPermission();
  const [loading, setLoading] = useState(false);
  const [changeview, setChangeView] = useState("");
  const [appNo, setAppNo] = useState("");

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState([]);

  const adminPermissiont = useSelector(
    (state) => state.adminFunction?.queue?.adminData?.email,
  );

  function switchView() {
    switch (changeview) {
      case "grid":
        return <CardView />;
      case "table":
        return <TableView />;
      default:
        return <TableView />;
    }
  }

  async function fetchStudents() {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/admin_directory/students/get_all`,
      )
      .then((response) => {
        dataFetch = response.data.allStudentsData;
        if (response?.data.status === 201) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        } else {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "warning",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim() === "") {
      setFiltered([]);
    } else {
      const filtered = dataFetch.filter(
        (student) =>
          student.admission_number
            ?.toLowerCase()
            .includes(term.toLowerCase()) ||
          student.academicInfo?.admission_number
            ?.toLowerCase()
            .includes(term) ||
          student.personalInfo?.first_Name?.toLowerCase().includes(term) ||
          student.personalInfo?.sur_Name?.toLowerCase().includes(term) ||
          student.personalInfo?.other_Name?.toLowerCase().includes(term) ||
          student.admissions?.date_admitted?.toLowerCase().includes(term) ||
          student.academicInfo?.department?.toLowerCase().includes(term),
      );
      setFiltered(filtered);
    }
  };

  function switchViews() {
    if (filtered.length > 0) {
      return (
        <tbody className="fx-cl">
          {filtered?.map((response, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td className="fx-ac space2">
                  <figure
                    className="fx-ac fx-jc"
                    style={{ border: "1px solid #f3f3f3" }}
                  >
                    {response.personalInfo?.passport ? (
                      <img src={response.personalInfo?.passport} alt="gal" />
                    ) : (
                      response.first_Name?.slice(0, 1).toUpperCase()
                    )}
                  </figure>
                  <span>
                    {response?.personalInfo?.first_Name +
                      " " +
                      response?.personalInfo?.sur_Name +
                      " " +
                      response?.personalInfo?.other_Name}
                  </span>
                </td>
                <td>
                  {response?.admission_number ||
                    response?.academicInfo?.admission_number}
                </td>
                <td>{response.personalInfo?.gender}</td>
                <td>{response.academicInfo?.course_of_study}</td>
                <td>+234{response.contactInfo?.phone_number}</td>
                {/* <td>{response.contactInfo?.email}</td> */}

                <td className="fx-ac space2">
                  <Link
                    className="neon-button fx-ac spacem"
                    to={`/management/student_data/${encodeURIComponent(
                      response.admission_number ||
                        response.academicInfo?.admission_number,
                    )}`}
                    style={{ color: "blue" }}
                    target="blank"
                  >
                    <PrivacyTipOutlinedIcon
                      style={{
                        fontSize: "1.4rem",
                        color: "#2a59a0",
                        fontweight: "700",
                      }}
                    />
                    <span>Data</span>
                  </Link>
                  <Link
                    className="neon-button edit fx-ac spacem"
                    to={`/management/student_data/${encodeURIComponent(
                      response.admission_number ||
                        response.academicInfo?.admission_number,
                    )}/updating`}
                    style={{
                      color: "#e52214",
                      // backgroundColor: "#d07a24",
                      borderRadius: "9.4rem",
                      fontweight: "700",
                      border: "1px solid #e52214",
                    }}
                    target="blank"
                  >
                    <BorderColorRoundedIcon
                      style={{ fontSize: "1.4rem", color: "#e52214" }}
                    />
                    <span>Edit</span>
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      );
    } else if (searchTerm.trim() !== "") {
      return <p className="no--found">No found</p>;
    } else {
      return (
        <tbody className="fx-cl">
          {dataFetch?.map((response, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td className="fx-ac space2">
                  <figure
                    className="fx-ac fx-jc"
                    style={{ border: "1px solid #f3f3f3" }}
                  >
                    {response.personalInfo?.passport ? (
                      <img src={response.personalInfo?.passport} alt="gal" />
                    ) : (
                      response.first_Name?.slice(0, 1).toUpperCase()
                    )}
                  </figure>
                  <span>
                    {response?.personalInfo?.first_Name +
                      " " +
                      response?.personalInfo?.sur_Name +
                      " " +
                      response?.personalInfo?.other_Name}
                  </span>
                </td>
                <td>
                  {response?.admission_number ||
                    response?.academicInfo?.admission_number}
                </td>
                <td>{response.personalInfo?.gender}</td>
                <td>{response.academicInfo?.course_of_study}</td>
                <td>+234{response.contactInfo?.phone_number}</td>

                <td className="fx-ac space2">
                  <Link
                    className="neon-button fx-ac spacem"
                    to={`/management/student_data/${encodeURIComponent(
                      response.admission_number ||
                        response.academicInfo?.admission_number,
                    )}`}
                    style={{ color: "blue" }}
                    target="blank"
                  >
                    <PrivacyTipOutlinedIcon
                      style={{
                        fontSize: "1.4rem",
                        color: "#2a59a0",
                        fontweight: "700",
                      }}
                    />
                    <span>Data</span>
                  </Link>
                  <Link
                    className="neon-button edit fx-ac spacem"
                    to={`/management/student_data/${encodeURIComponent(
                      response.admission_number ||
                        response.academicInfo?.admission_number,
                    )}/updating`}
                    style={{
                      color: "#e52214",
                      // backgroundColor: "#d07a24",
                      borderRadius: "9.4rem",
                      fontweight: "700",
                      border: "1px solid #e52214",
                    }}
                    target="blank"
                  >
                    <BorderColorRoundedIcon
                      style={{ fontSize: "1.4rem", color: "#e52214" }}
                    />
                    <span>Edit</span>
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      );
    }
  }

  function TableView() {
    return (
      <table className="fx-cl spacem">
        <thead className="fx-cl spacem">
          <tr>
            <th>S/N</th>
            <th>Student Name</th>
            <th>Admission No.</th>
            <th>Gender</th>
            <th>Department</th>
            <th>Phone number</th>
            <th>Action </th>
          </tr>
        </thead>
        {switchViews()}
      </table>
    );
  }

  function CardView() {
    return (
      <div className="girdViewCont">
        {dataFetch?.map((response, index) => {
          return (
            <figure className="gridViewCard ">
              <h4>
                {" "}
                {response?.personalInfo?.first_Name +
                  " " +
                  response?.personalInfo?.sur_Name +
                  " " +
                  response?.personalInfo?.other_Name}
              </h4>
              <div>
                <div className="fx-cl spacem">
                  <div className="fx-ac">
                    <span>Programme</span>{" "}
                    <span> {response.academicInfo?.programme}</span>
                  </div>
                </div>
              </div>
            </figure>
          );
        })}
      </div>
    );
  }

  useEffect(() => {
    fetchStudents();
  }, []);

  return (
    <>
      {loading ? (
        <IsLoading />
      ) : (
        <div className=" students_data">
          <div className="fx-cl">
            <header className="fx-ac fx-jb space4">
              <div className="adminSearchCont">
                <span style={{ fontSize: "1.2rem" }}>
                  Search by name/dept/Adm/date
                </span>

                <div className="adminSearch fx-jb">
                  <input
                    type="text"
                    name="application_number"
                    placeholder="im looking for..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                  <button
                    onClick={() => alert("no function running currently")}
                  >
                    <SearchIcon fontSize="large" />
                  </button>
                </div>
              </div>

              <div className="fx-ac space2">
                <ExportPDFButton currentRows={filtered} dataFetch={dataFetch} />
                <ExportExcelJSButton
                  currentRows={filtered}
                  dataFetch={dataFetch}
                />
                <span onClick={() => setChangeView("table")}>
                  <TocOutlinedIcon />
                </span>
                <span onClick={() => setChangeView("grid")}>
                  <AppsOutlinedIcon />
                </span>
              </div>
            </header>
          </div>
          {switchView()}
        </div>
      )}
    </>
  );
}
